import { navLinks } from '@/mocks/gossipData';

interface Props {
  kicker: string;
  title: string;
  accent?: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ kicker, title, accent, desc, align = 'left' }: Props) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'text-center' : ''}>
      <div
        className={`inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold tracking-wide text-secondary-900`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
        {kicker}
      </div>
      <h2
        className={`mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[2rem] ${
          isCenter ? 'mx-auto max-w-2xl' : ''
        }`}
      >
        {title}
        {accent ? <span className="text-primary-600"> {accent}</span> : null}
      </h2>
      {desc ? (
        <p className={`mt-3 text-sm leading-6 text-foreground-600 md:text-base ${isCenter ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}